import { render, staticRenderFns } from "./UsersMembersTab.vue?vue&type=template&id=224ac1fa&scoped=true"
import script from "./UsersMembersTab.vue?vue&type=script&lang=js"
export * from "./UsersMembersTab.vue?vue&type=script&lang=js"
import style0 from "./UsersMembersTab.vue?vue&type=style&index=0&id=224ac1fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224ac1fa",
  null
  
)

export default component.exports